"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupDateRangePickerWrapper = exports.PopupDateRangePickerLegend = exports.PopupDateRangePickerFieldset = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _context = require("../../../context");

var _layout = require("../../../layout");

var _text = require("../../../text");

var _utils = require("../../../utils");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PopupDateRangePickerFieldset = ( /*#__PURE__*/0, _styledBase.default)(_layout.Col.withComponent('fieldset', {
  target: "e1t8kmfc1"
}), {
  target: "e1t8kmfc0"
})(process.env.NODE_ENV === "production" ? {
  name: "ki54ph",
  styles: "border:none;padding:0;"
} : {
  name: "ki54ph",
  styles: "border:none;padding:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2RhdGUtcGlja2VyL3BvcHVwLWRhdGUtcGlja2VyL3BvcHVwLWRhdGUtcmFuZ2UtcGlja2VyL2hlbHBlckNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWTRDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2RhdGUtcGlja2VyL3BvcHVwLWRhdGUtcGlja2VyL3BvcHVwLWRhdGUtcmFuZ2UtcGlja2VyL2hlbHBlckNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHN0eWxlZFdpdGhUaGVtZSB9IGZyb20gJy4uLy4uLy4uL2NvbnRleHQnO1xuaW1wb3J0IHsgQ29sIH0gZnJvbSAnLi4vLi4vLi4vbGF5b3V0JztcbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi8uLi8uLi90ZXh0JztcbmltcG9ydCB7XG4gIENTU1ZhbHVlLFxuICBnZXRUaGVtZVNwYWNlLFxuICBMQUJFTF9DT0xPUixcbiAgTEFCRUxfU0laRVxufSBmcm9tICcuLi8uLi8uLi91dGlscyc7XG5cbmV4cG9ydCBjb25zdCBQb3B1cERhdGVSYW5nZVBpY2tlckZpZWxkc2V0ID0gc3R5bGVkKFxuICBDb2wud2l0aENvbXBvbmVudCgnZmllbGRzZXQnKVxuKSh7XG4gIGJvcmRlcjogJ25vbmUnLFxuICBwYWRkaW5nOiAwXG59KTtcblxuZXhwb3J0IGNvbnN0IFBvcHVwRGF0ZVJhbmdlUGlja2VyTGVnZW5kID0gc3R5bGVkV2l0aFRoZW1lKFxuICBUZXh0LndpdGhDb21wb25lbnQoJ2xlZ2VuZCcpXG4pPHtcbiAgcGFkZGluZz86IENTU1ZhbHVlO1xufT4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgbWFyZ2luQm90dG9tOiBnZXRUaGVtZVNwYWNlKHRoZW1lLCAnUzMwMCcpXG59KSk7XG5Qb3B1cERhdGVSYW5nZVBpY2tlckxlZ2VuZC5kZWZhdWx0UHJvcHMgPSB7XG4gIGNvbG9yOiBMQUJFTF9DT0xPUixcbiAgZm9udFNpemU6IExBQkVMX1NJWkUsXG4gIHBhZGRpbmc6IDBcbn07XG5cbmV4cG9ydCBjb25zdCBQb3B1cERhdGVSYW5nZVBpY2tlcldyYXBwZXIgPSBzdHlsZWRXaXRoVGhlbWUoQ29sKShcbiAgKHsgdGhlbWUgfSkgPT4gKHtcbiAgICBnYXA6IGdldFRoZW1lU3BhY2UodGhlbWUsICdTMjAwJylcbiAgfSlcbik7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.PopupDateRangePickerFieldset = PopupDateRangePickerFieldset;
var PopupDateRangePickerLegend = (0, _context.styledWithTheme)(_text.Text.withComponent('legend', {
  target: "e1t8kmfc2"
}))(function (_ref) {
  var theme = _ref.theme;
  return {
    marginBottom: (0, _utils.getThemeSpace)(theme, 'S300')
  };
});
exports.PopupDateRangePickerLegend = PopupDateRangePickerLegend;
PopupDateRangePickerLegend.defaultProps = {
  color: _utils.LABEL_COLOR,
  fontSize: _utils.LABEL_SIZE,
  padding: 0
};
var PopupDateRangePickerWrapper = (0, _context.styledWithTheme)(_layout.Col)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    gap: (0, _utils.getThemeSpace)(theme, 'S200')
  };
});
exports.PopupDateRangePickerWrapper = PopupDateRangePickerWrapper;